import { useRecoilValue } from 'recoil';
import { accountDataState } from 'components/account/account.state';
import { useQuery } from '@apollo/client';
import { GET_IS_CONSOLE_USER_ACTIVE } from 'plugins/deep-visibility/actions/sentinel-one/queries/console-endpoint';

function S1ConsoleUserManager(): JSX.Element {
  const accountData = useRecoilValue(accountDataState);
  const { S1ConsoleURL } = accountData;

  const { data } = useQuery(GET_IS_CONSOLE_USER_ACTIVE, {
    variables: { console: S1ConsoleURL },
    pollInterval: 60000,
    // S1ConsoleURL comes from SSO login, so if a user logs directly into DataSet instance, this will be `null`
    skip: !S1ConsoleURL,
  });
  if (data && !data.isS1UserActive) {
    window.location.assign(`${S1ConsoleURL}/login`);
  }

  return <></>;
}

export default S1ConsoleUserManager;
